var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Form, FormGroup, Label, Input, Button } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import Page from '../Page';
import { getQueryParam } from '../../../utils/urlUtils';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import { ApplicationContext } from '../../../ApplicationContext';
import FormField from '../../components/ui/FormField/FormField';
import ConfirmRegistrationCommand from '../../../commands/authentication/ConfirmRegistrationCommand';
import { Link } from 'react-router-dom';
import Routes from '../../../routes/RoutesConfig';
import { FormErrorContext } from '../../../FormErrorContext';
/**
 *
 */
var ConfirmRegistration = /** @class */ (function (_super) {
    __extends(ConfirmRegistration, _super);
    /**
     *
     */
    function ConfirmRegistration(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onError = _this.onError.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        return _this;
    }
    /**
     *
     */
    ConfirmRegistration.prototype.componentDidMount = function () {
        var _this = this;
        var validationToken = getQueryParam('validationToken');
        this.setState({ token: validationToken }, function () {
            if (validationToken) {
                _this.onSubmit();
            }
        });
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    ConfirmRegistration.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl);
    };
    /**
     *
     * @returns {*}
     */
    ConfirmRegistration.prototype.render = function () {
        return (React.createElement(Page, { pageName: "confirm-registration" },
            React.createElement("div", { className: "container vh-100 align-items-center" },
                React.createElement("div", { className: "row h-75 justify-content-center align-items-center" },
                    React.createElement("div", { className: "card col-md-8 col-lg-5" },
                        React.createElement("h2", { className: "card-header" },
                            React.createElement(FormattedMessage, { id: "page.confirmregistration.title" })),
                        React.createElement("div", { className: "card-body" },
                            React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                                React.createElement(Form, { onSubmit: this.onSubmit, autoComplete: "off" },
                                    React.createElement("fieldset", { disabled: this.state.submitting },
                                        React.createElement(FormGroup, null,
                                            React.createElement("div", { className: "row" },
                                                React.createElement("div", { className: "col" },
                                                    React.createElement(Label, { for: "token" },
                                                        React.createElement(FormattedMessage, { id: "page.confirmregistration.field.code" })))),
                                            React.createElement(FormField, null,
                                                React.createElement(Input, { name: "token", id: "token", value: this.state.token, type: "textarea", required: true, onChange: this.onInputChange }))),
                                        React.createElement(Button, { className: "w-100 mb-3", color: "primary", type: "submit" },
                                            React.createElement("span", { className: "fe fe-check-square mr-2" }),
                                            React.createElement(FormattedMessage, { id: "page.confirmregistration.confirm" })),
                                        React.createElement("p", { className: "text-center" },
                                            React.createElement("small", { className: "text-muted text-center" },
                                                React.createElement(FormattedMessage, { id: "page.confirmregistration.alreadyaccount" }),
                                                React.createElement(Link, { to: Routes.LOGIN.path },
                                                    React.createElement(FormattedMessage, { id: "page.confirmregistration.login" })),
                                                ".")))))))))));
    };
    /**
     *
     */
    ConfirmRegistration.prototype.onSuccess = function () {
        this.setState({ submitting: false });
    };
    /**
     *
     * @param error
     */
    ConfirmRegistration.prototype.onError = function (error) {
        createErrorResponse(this, error);
    };
    /**
     *
     * @param e
     */
    ConfirmRegistration.prototype.onSubmit = function (e) {
        e ? e.preventDefault() : null;
        if (this.state.submitting) {
            return;
        }
        this.setState({ errors: null, submitting: true });
        var intl = this.props.intl;
        var command = new ConfirmRegistrationCommand();
        command.execute(this.state.token, intl).then(this.onSuccess).catch(this.onError);
    };
    /**
     *
     * @param e
     */
    ConfirmRegistration.prototype.onInputChange = function (e) {
        var nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    };
    return ConfirmRegistration;
}(React.Component));
ConfirmRegistration.contextType = ApplicationContext;
export default injectIntl(ConfirmRegistration);
